import React from 'react';
import { AlertCircle } from 'lucide-react';

interface SaveStatusBadgeProps {
    status: 'idle' | 'saving' | 'saved' | 'error';
}

/**
 * Badge component to display save status
 * Only shows error state after all retries have failed
 */
export const SaveStatusBadge: React.FC<SaveStatusBadgeProps> = ({ status }) => {
    // Only show error status - saving/saved are silent
    if (status !== 'error') {
        return null;
    }

    return (
        <span className="badge bg-danger d-flex align-items-center" style={{ fontSize: '0.875rem', padding: '0.5rem 0.75rem' }}>
            <AlertCircle size={14} className="me-2" />
            Kunde inte spara ändringar
        </span>
    );
};
